import { Typography } from "@mui/material";

interface PostScriptProps {
  text?: string;
  italics?: string;
}

export const PostScript: React.FC<PostScriptProps> = ({ text, italics }) => {
  return (
    <>
      <Typography
        sx={{
          color: "gray",
          fontSize: "0.8rem",
          marginTop: "0.5rem",
          lineHeight: "15px",
        }}
      >
        {text}
      </Typography>
      <Typography
        sx={{
          color: "gray",
          fontSize: "0.8rem",
          lineHeight: "15px",
          fontStyle: "italic",
        }}
      >
        {italics}
      </Typography>
    </>
  );
};

export default PostScript;
